module.exports = __webpack_public_path__ + "img/v_card.180d1eb4.jpeg";